<template>
  <div>
    <MasterLayout>
      <section class="row mx-auto" style="margin-top: 100px; width: 99%">
        <div
          class="product_summary__wrapper radius-5 col-md-4 col-sm-12"
          style="padding: 1px"
        >
          <div class="text-center mt-4">
            <img src="@/assets/img/shuffle (2).svg" width="" />
            <h3 class="change_price_header">{{ $t("text.loyalty.title") }}</h3>
          </div>
          <div class="price_change_form_section mt-3 radius-5">
            <form>
              <div class="row align-items-center mt-3 justify-content-center">
                <div class="col-md-10">
                  <label> {{ $t("text.products.product") }}</label>

                  <div class="input__block">
                    <select v-model="product">
                      <option value="selectProduct">
                        {{ $t("text.cDrystock.supplies.selectProd") }}
                      </option>
                      <option
                        :value="product.productId"
                        v-for="(product, index) in products"
                        :key="index"
                      >
                        <span>
                          {{ product.productName }}
                        </span>
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="row align-items-center mt-3 justify-content-center">
                <div class="col-md-10">
                  <label> {{ $t("text.loyalty.pointVolume") }}</label>
                  <img
                    src="https://epump.com.ng/images/information-button.svg"
                    id="tooltip-target-1"
                    alt="information button"
                  />
                  <b-tooltip
                    target="tooltip-target-1"
                    triggers="hover"
                    placement="right"
                  >
                    {{ $t("text.loyalty.howLtrsPts") }}
                  </b-tooltip>
                  <div class="price_change_input_wrapper">
                    <input
                      min="0"
                      type="number"
                      class="border-0"
                      v-model="litresForPoint"
                    />
                  </div>
                </div>
              </div>

              <div class="row align-items-center mt-3 justify-content-center">
                <div class="col-md-10 position-relative">
                  <label> {{ $t("text.loyalty.ptsVal") }}</label>
                  <img
                    src="https://epump.com.ng/images/information-button.svg"
                    alt="information button"
                    id="tooltip-target-2"
                  />
                  <b-tooltip
                    target="tooltip-target-2"
                    triggers="hover"
                    placement="right"
                  >
                    {{
                      $t("text.loyalty.worth", {
                        currency: `(${company ? company.currency : ""})`,
                      })
                    }}
                  </b-tooltip>
                  <div class="price_change_input_wrapper">
                    <input
                      min="0"
                      type="number"
                      class="border-0"
                      v-model="pointValue"
                    />
                  </div>
                </div>
              </div>
              <div class="row align-items-center mt-3 justify-content-center">
                <div class="col-md-10">
                  <label>{{ $t("text.loyalty.redeemablePoint") }}</label>
                  <img
                    src="https://epump.com.ng/images/information-button.svg"
                    alt="information button"
                    id="tooltip-target-3"
                  />
                  <b-tooltip
                    target="tooltip-target-3"
                    triggers="hover"
                    placement="right"
                  >
                    {{ $t("text.loyalty.pointConvert") }}
                  </b-tooltip>
                  <div class="price_change_input_wrapper">
                    <input
                      min="0"
                      type="number"
                      class="border-0"
                      v-model="redeemablePoint"
                    />
                  </div>
                </div>
              </div>

              <div class="row align-items-center mt-3 justify-content-center">
                <div class="col-md-10">
                  <label>{{ $t("text.calendar.dateRange") }}</label>
                  <img
                    src="https://epump.com.ng/images/information-button.svg"
                    alt="information button"
                    id="tooltip-target-3"
                  />
                  <b-tooltip
                    target="tooltip-target-3"
                    triggers="hover"
                    placement="right"
                  >
                    {{ $t("text.calendar.dateRange") }}
                  </b-tooltip>
                  <div class="price_change_input_wrapper">
                    <vue-ctk-date-time-picker
                      v-model="dateRange"
                      :min-date="minDate"
                      :range="true"
                      :autoClose="true"
                      :custom-shortcuts="[]"
                      color="#290C53"
                      format="DDMMYYYY"
                      formatted="DD/MM/YYYY"
                      :label="$t('text.calendar.dateRange')"
                    />
                  </div>
                </div>
              </div>

              <div
                class="row align-items-center mt-4 justify-content-center update_price_btn_divs"
              >
                <div class="col-md-10">
                  <button
                    class="save__btn record_expense_btn mr-2 btn_primary_color"
                    style="width: 100%"
                    @click="setupLoyalty"
                    :disabled="isButtonDisabled ? true : null"
                    :style="[
                      isButtonDisabled
                        ? { cursor: 'not-allowed' }
                        : { cursor: 'pointer' },
                    ]"
                  >
                    {{ $t("text.loyalty.title") }}
                    <span>
                      <img
                        src="@/assets/img/git_loader.gif"
                        style="display: none"
                        width="20px"
                        class="loader ml-2"
                      />
                    </span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>

        <section class="col-md-8 col-sm-12">
          <section class="section__row">
            <div class="">
              <div class="">
                <ejs-grid
                  v-show="!showLoader"
                  ref="dataGrid"
                  :created="refreshGrid"
                  :allowPaging="true"
                  :allowSorting="true"
                  :pageSettings="pageSettings"
                  :toolbar="toolbar"
                  :searchSettings="search"
                  :allowExcelExport="true"
                  :allowPdfExport="true"
                  :toolbarClick="toolbarClick"
                  :excelQueryCellInfo="excelQueryCellInfo"
                  :locale="usedLang"
                >
                  <e-columns>
                    <e-column
                      width="40"
                      field="index"
                      headerText="#"
                    ></e-column>

                    <e-column
                      field="recordedBy"
                      width="250"
                      :headerText="$t('text.pumpsFault.recordedBy')"
                    ></e-column>

                    <e-column
                      field="productName"
                      width="250"
                      :headerText="$t('text.products.product')"
                    ></e-column>

                    <e-column
                      field="litresForPoint"
                      width="180"
                      format="N2"
                      :headerText="$t('text.loyalty.litresForPoint')"
                    ></e-column>

                    <e-column
                      field="pointValue"
                      width="180"
                      format="N2"
                      :headerText="$t('text.loyalty.pointValue')"
                    ></e-column>

                    <e-column
                      field="redeemablePoint"
                      width="180"
                      format="N2"
                      :headerText="$t('text.loyalty.redeemablePoint')"
                    ></e-column>

                    <e-column
                      field="startDate"
                      width="150"
                      :headerText="$t('text.loyalty.startDate')"
                    ></e-column>

                    <e-column
                      field="endDate"
                      width="150"
                      :headerText="$t('text.loyalty.endDate')"
                    ></e-column>
                  </e-columns>
                </ejs-grid>
                <TableLoader :showLoader="showLoader" />
                <!-- <DropDown :details="details" /> -->
              </div>
            </div>
          </section>
        </section>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import MasterLayout from "@/views/Company/MasterLayout.vue";
import configObject from "@/config";

import TableLoader from "@/components/tableLoader/index";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";

import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Loyalty :: Epump Portal",
  name: "DashboardHome",
  components: {
    MasterLayout,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      products: [],
      product: "selectProduct",
      litresForPoint: 0,
      pointValue: 0,
      redeemablePoint: 0,
      isButtonDisabled: false,
      loyaltyDetails: {},
      company: null,

      showLoader: false,
      usedLang: this.$store.getters.getLanguage,
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },

      minDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      startDate: this.$moment().format("MMMM D, YYYY"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      pluginStartDate: this.$route.query.startDate
        ? this.$moment(this.$route.query.startDate).format("D-M-YYYY")
        : this.$moment().format("D-M-YYYY"),
      pluginEndDate: this.$route.query.endDate
        ? this.$moment(this.$route.query.endDate).format("D-M-YYYY")
        : this.$moment().format("D-M-YYYY"),
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
    };
  },
  watch: {
    company(company) {
      if (company !== null) {
        this.getLoyalty();
        this.getCompanyProducts();
      }
    },

    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
      }
    },
  },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
    });
    if (this.$route.query.companyId) {
      this.getLoyalty();
      this.getCompanyProducts();
    }
  },
  mounted() {},
  methods: {
    //Requests
    getCompanyProducts() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/Products/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          configObject.authConfig()
        )
        .then((response) => {
          this.products = response.data;
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
        });
    },
    getLoyalty() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/Loyalty/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          configObject.authConfig()
        )
        .then((res) => {
          let index = 0;

          res.data.forEach((element) => {
            index++;
            element.index = index;
            element.startDate = this.$moment(element.startDate).format(
              "YYYY-MM-DD"
            );
            element.endDate = this.$moment(element.endDate).format(
              "YYYY-MM-DD"
            );
          });

          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: res.data,
          });

          this.litresForPoint = res.data.litresForPoint;
          this.pointValue = res.data.pointValue;
          this.redeemablePoint = res.data.redeemablePoint;
          this.loyaltyDetails = res.data;
        })
        .catch((e) => {});
    },
    setupLoyalty(e) {
      e.preventDefault();

      if (this.product === "selectProduct") {
        this.$toast.open({
          message: this.$t("text.cDrystock.supplies.selectProd"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (!this.litresForPoint) {
        this.$toast.open({
          message: this.$t("text.loyalty.literPointErr"),
          type: "error",
          duration: 5000,
        });
        return;
      }

      if (!this.pointValue) {
        this.$toast.open({
          message: this.$t("text.loyalty.pointValueErr"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (!this.redeemablePoint) {
        this.$toast.open({
          message: this.$t("text.loyalty.redeemPointErr"),
          type: "error",
          duration: 5000,
        });
        return;
      }

      let data = {
        litresForPoint: parseFloat(this.litresForPoint),
        pointValue: parseFloat(this.pointValue),
        redeemablePoint: parseFloat(this.redeemablePoint),
        productId: this.product,
        startDate: this.startDate,
        endDate: this.endDate,
      };

      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Company/SetupLoyalty/${this.$route.query.companyId}`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.getLoyalty();
          this.$toast.open({
            message: this.$t("text.loyalty.loyaltySuccess"),
            type: "success",
            duration: 3000,
          });

          $(".loader").hide();
          this.isButtonDisabled = false;
          this.litresForPoint = 0;
          this.pointValue = 0;
          this.redeemablePoint = 0;
          this.closeModal();
        })
        .catch((e) => {
          this.$toast.open({
            message: e.response.data.message,
            type: "error",
            duration: 3000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    },

    //Utilities
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    excelQueryCellInfo(args) {
      if (args.column.field == "date") {
        args.value = this.$moment(args.value).format("DD/MM/YYYY");
      }
    },
  },
};
</script>
